import { MySubLabel } from "./styles"

export const SubLabel = (props) => {
    return (
        <MySubLabel>{props.children}</MySubLabel>
    )
}